export default __webpack_public_path__ + "static/girls-innovator-e4d6f16b0a16229f472f6c4726afc45c.png";